import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IResponse } from '../@Interfaces';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(private http: HttpClient) {}

  public async sendEmails(body: any): Promise<{ email: string; error: any }[]> {
    return new Promise((resolve, reject) => {
      this.http
        .post<IResponse<{ email: string; error: any }[]>>(
          'api/emails/mass',
          body
        )
        .subscribe({
          next: (response: IResponse<{ email: string; error: any }[]>) => {
            console.log('success');
            resolve(response.data);
          },
          error: (error: any) => {
            console.log('error sending emails ', error);
            reject();
          },
        });
    });
  }
}
